/**
 * THE currencies a practice may operate in — the frontend's one copy of backend
 * `platform_helpers.OPERATING_CURRENCIES`, same codes, same order.
 *
 * Lowercase ISO, because that is how every document stores a currency: money grids are
 * keyed `{"usd": 49.0, "cad": 49.0}` (migration `_lowercase_money_grid_keys`) and
 * `tenants.currency` holds `"usd"`/`"cad"`. A grid is therefore INDEXED with these codes
 * and only ever uppercased at render, through `currencyLabel`.
 *
 * Before this module the list existed three times: twice lowercase and current (signup,
 * the public pricing grid) and once uppercase with two retired codes (the super-admin
 * plane). The uppercase copy indexed lowercase grids with "CAD", so every price box in
 * the plan and catalogue editors hydrated empty and every save was refused. Any surface
 * that needs the list imports it from here; none may spell it.
 */
export const OPERATING_CURRENCIES = Object.freeze(["usd", "cad"]);

/** `"usd"` → `"USD"`: a stored code as printed. A missing code prints as nothing. */
export const currencyLabel = (code) => String(code ?? "").trim().toUpperCase();

/** Is `code` (either case — it may come from a query string) an operating currency? */
export const isOperatingCurrency = (code) =>
  OPERATING_CURRENCIES.includes(String(code ?? "").trim().toLowerCase());
